import { Popper } from "@mui/material";
import {  Cancel,  ServerSquareUpdate } from "../../../assets";
import { Button, CustomModal, Dropdown, EmptyTable, FilterInput, Input, Layout } from "../../components";
import { PolicyController } from "../../controllers";
import { Helmet } from "react-helmet-async";

class Policy extends PolicyController {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <Layout title=" بیمه نامه ها ">
        <Helmet>
          <title> بیمه نامه ها | بیمه زندگی هامرز</title>
        </Helmet>
        <div className="policy-filter">
          <FilterInput showSubmitReq buttonTitle="فیلترها" placeholder="فیلتر های بیمه نامه" onClick={() => this.setState({ openModal: !this.state.openModal })} str={this.state.str} />
          <div className="submit-request">
            <Button onClick={() => window.location.href = "/under-construction"} title="ثبت درخواست " myStyle="filter-btn hide-mobile" />

          </div>
        </div>
        <div className="policy table-responsive scrollbar ">
          <table className="table hide-mobile">
            <thead>
              <tr>
                <th scope="col">ردیف</th>
                <th scope="col">نام و نام خانوادگی</th>
                <th scope="col">کد ملی</th>
                <th scope="col">تاریخ شروع</th>
                <th scope="col">تاریخ پایان</th>
                <th scope="col">شماره بیمه نامه</th>
                <th scope="col">نحوه پرداخت</th>
                <th scope="col">وضعیت ب. ن</th>
                <th scope="col">وضعیت</th>
                <th scope="col">عملیات</th>
              </tr>
            </thead>
            {/* <tbody> */}
              {/* <tr>
                                <th>1</th>
                                <td>محمد حسین والی زاده</td>
                                <td>1451513224</td>
                                <td>1402/02/21</td>
                                <td>1402/02/21</td>
                                <td>پ-2681315</td>
                                <td>سالانه</td>
                                <td>---</td>
                                <td className="green-text"><img src={VerifiedCheck} alt="هامرز" /> فعال</td>
                                <td>                        <Button myStyle="bg-light-blue table-btn" title="عملیات" onClick={this.handleClick}/>
                                </td>
                            </tr>
                            <tr>
                                <th>2</th>
                                <td>امیر حسین نبوی</td>
                                <td>1451513224</td>
                                <td>1402/02/21</td>
                                <td>1402/02/21</td>
                                <td>پ-2681315</td>
                                <td>سالانه</td>
                                <td>---</td>
                                <td className="primary-text"> <img src={BillCheck} alt="هامرز" /> ارسال به مالی شده</td>
                                <td>                        <Button myStyle="bg-light-blue table-btn" title="عملیات" onClick={this.handleClick}/>
                                </td>
                            </tr>
                            <tr>
                                <th className="inactive">3</th>
                                <td className="inactive">دریا محمدی</td>
                                <td className="inactive">1451513224</td>
                                <td className="inactive">1402/02/21</td>
                                <td className="inactive">1402/02/21</td>
                                <td className="inactive">پ-2681315</td>
                                <td className="inactive">سالانه</td>
                                <td className="inactive">---</td>
                                <td className="inactive danger-text">  <img src={Danger} alt="هامرز" /> منقضی شده</td>
                                <td className="">                        <Button myStyle="bg-light-blue table-btn" title="عملیات" onClick={this.handleClick} />
                                </td>
                            </tr>
                            <tr>
                                <th>4</th>
                                <td>دریا محمدی</td>
                                <td>1451513224</td>
                                <td>1402/02/21</td>
                                <td>1402/02/21</td>
                                <td>پ-2681315</td>
                                <td>سالانه</td>
                                <td>---</td>
                                <td className="danger-text"> <img src={DangerTriangle} alt="هامرز" /> انقضا تا 7 روز</td>
                                <td>
                                    <Button myStyle="bg-light-blue table-btn" title="عملیات" aria-describedby={this.id} onClick={this.handleClick} />
                                </td>
                            </tr> */}


            {/* </tbody> */}

          </table>
              <EmptyTable title=" بیمه نامه ای ثبت نشده است "/>
          {/* <Accordion className="policy-accordion hide-desktop">
            <AccordionSummary
              expandIcon={<img src={Arrowdown2} alt="هامرز" />}
              aria-controls="panel1a-content"
              className="summsry"
              id="panel1a-header"
            >
              <TableRowResponsive title="ردیف" value="1" />
              <TableRowResponsive title="نام و نام خانوادگی" value=" حسین والی زاده" />
              <TableRowResponsive title="کد ملی" value="1451513224" />
            </AccordionSummary>
            <AccordionDetails
              className="d-flex flex-wrap"
            >
              <TableRowResponsive title="تاریخ شروع" value="1402/02/21" />
              <TableRowResponsive title="تاریخ پایان" value="1402/02/21" />
              <TableRowResponsive title="شماره بیمه نامه" value="پ-2681315" />

            </AccordionDetails>
            <AccordionDetails
              className="d-flex flex-wrap"
            >

              <TableRowResponsive title="نحوه پرداخت" value="سالانه" />
              <TableRowResponsive title="وضعیت ب. ن" value="----" />
              <TableRowResponsive title="وضعیت" value=" فعال" />
            </AccordionDetails>
            <AccordionDetails
              className="d-flex flex-wrap"
            >
              <Button myStyle="bg-light-blue table-btn" title="عملیات" onClick={this.handleClick} />
            </AccordionDetails>


          </Accordion> */}

          {/* <Pagination
            className="custom-pagination"
            count={23}
            size="small"
            renderItem={(item) => (
              <PaginationItem
                slots={{ previous: Forward, next: ArrowBack }}
                {...item}
              />
            )}
          /> */}
          {this.state.open &&
            <div className="backdrop" onClick={() => this.setState({ open: !this.state.open })}>
              {/* <ClickAwayListener  onClickAway={()=>this.setState({open:false})}> */}


              <Popper placement="right" id={this.id} open={this.state.open} anchorEl={this.state.anchorEl}
                className="policy-popover"
                disablePortal={false}
                modifiers={[
                  {
                    name: 'flip',
                    enabled: true,
                    options: {
                      altBoundary: true,
                      rootBoundary: 'document',
                      padding: 8,
                    },
                  },
                  {
                    name: 'preventOverflow',
                    enabled: false,
                    options: {
                      altAxis: false,
                      altBoundary: true,
                      tether: true,
                      rootBoundary: 'document',
                      padding: 8,
                    },
                  },
                  {
                    name: 'arrow',
                    enabled: true,
                    options:
                      <div> 5 </div>,

                  },
                ]}
              >

                <div className="policy-popover-content ">
                  <span className="ancher"></span>
                  <div className="policy-popover-content-item" > <img src={ServerSquareUpdate} alt="هامرز" /><span>
                    ارسال به مالی
                  </span></div>
                  <div className="policy-popover-content-item" > <img src={ServerSquareUpdate} alt="هامرز" /> <span>
                    حذف مشترک
                  </span>  </div>
                  <div className="policy-popover-content-item" > <img src={ServerSquareUpdate} alt="هامرز" /> <span>
                    ارسال اطلاعیه تمدید
                  </span>  </div>
                  <div className="policy-popover-content-item" > <img src={ServerSquareUpdate} alt="هامرز" /> <span>
                    ویرایش
                  </span>   </div>
                  <div className="policy-popover-content-item" > <img src={ServerSquareUpdate} alt="هامرز" /> <span>
                    لغو پرونده
                  </span>   </div>
                </div>
              </Popper >
              {/* </ClickAwayListener> */}
            </div>
          }
        </div>
        <CustomModal openModal={this.state.openModal} onClose={() => this.setState({ openModal: !this.state.openModal })}>
          <>
            <div className="custom-modal-main-title hide-desktop">
              <h1 className="title">
                فیلتر های کارمزد ها
              </h1>
              <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={() => this.setState({ openModal: !this.state.openModal })} />
            </div>
            <div className="filter-selected">
              <div>
                <span className="text ml-50 hide-mobile bold">
                  فیلتر های اعلام شده :
                </span>{" "}
              </div>
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() => this.setState({ openModal: !this.state.openModal })} />
            </div>
            <h2 className="custom-modal-title">
              بر اساس اطلاعات بیمه گذار
            </h2>
            <div className="custom-modal-row">
              <Input myStyle="custom-modal-item" title="نام بیمه گذار" value={this.state.value} onChange={this.handleChange} />
              <Input myStyle="custom-modal-item" title="نام خانوادگی بیمه گذار" value={this.state.value} onChange={this.handleChange} />
              <Input myStyle="custom-modal-item" title="کد ملی بیمه گذار" value={this.state.value} onChange={this.handleChange} />
            </div>
            <h2 className="custom-modal-title mt-33">
              بر اساس اطلاعات بیمه
            </h2>
            <div className="custom-modal-row ">
              <Input myStyle="custom-modal-item" title="شماره بیمه نامه" value={this.state.value} onChange={this.handleChange} />
              <Input myStyle="custom-modal-item" title="نوع بیمه نامه" value={this.state.value} onChange={this.handleChange} />
              <Dropdown myStyle="custom-modal-item" title="وضعیت بیمه نامه" value={this.state.value} onChange={this.handleChange} />
            </div>
            <div className="custom-modal-row ">

              <Dropdown myStyle="custom-modal-item" title="وضعیت" value={this.state.value} onChange={this.handleChange} />
            </div>
            <div className="custom-modal-confirm">
              <Button myStyle="bg-green" title="اعمال" />
            </div>
          </>
        </CustomModal>
      </Layout>
    )
  }
}
export default Policy;